import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
    exportAs: 'appDynamicForm',
    selector: 'app-dynamic-form',
    styleUrls: ['dynamic-form.component.scss'],
    template: `
    <form
      class="dynamic-form"
      [formGroup]="form"
      (ngSubmit)="submitted.emit(form.value)">
      <ng-container
        *ngFor="let field of config;"
        appDynamicField
        [config]="field"
        [group]="form">
      </ng-container>
    </form>
  `
})
export class DynamicFormComponent implements OnInit {
    @Input()
    config: any[] = [];

    form: FormGroup;

    @Output()
    submitted: EventEmitter<any> = new EventEmitter<any>();

    constructor(private fb: FormBuilder) { }

    ngOnInit() {
        this.form = this.createGroup();
    }

    createGroup() {
        const group = this.fb.group({});
        this.config.forEach(control => group.addControl(control.name, this.fb.control('')));
        return group;
    }

    clearForm() {
        console.log('clear form');
        this.form.reset();
    }
}



// WEBPACK FOOTER //
// ./src/app/_dynamic_form/containers/dynamic_form/dynamic-form.component.ts